/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertUserDto
 */
export interface UpsertUserDto {
    /**
     * The display name.
     * @type {string}
     * @memberof UpsertUserDto
     */
    name: string;
    /**
     * The email address.
     * @type {string}
     * @memberof UpsertUserDto
     */
    email: string;
    /**
     * The user roles.
     * @type {Array<string>}
     * @memberof UpsertUserDto
     */
    roles: Array<string> | null;
    /**
     * The optional password.
     * @type {string}
     * @memberof UpsertUserDto
     */
    password: string | null;
    /**
     * The user group ID.
     * @type {string}
     * @memberof UpsertUserDto
     */
    userGroupId: string;
    /**
     * The API Key.
     * @type {string}
     * @memberof UpsertUserDto
     */
    apiKey: string | null;
}

/**
 * Check if a given object implements the UpsertUserDto interface.
 */
export function instanceOfUpsertUserDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "roles" in value;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "userGroupId" in value;
    isInstance = isInstance && "apiKey" in value;

    return isInstance;
}

export function UpsertUserDtoFromJSON(json: any): UpsertUserDto {
    return UpsertUserDtoFromJSONTyped(json, false);
}

export function UpsertUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'],
        'roles': json['roles'],
        'password': json['password'],
        'userGroupId': json['userGroupId'],
        'apiKey': json['apiKey'],
    };
}

export function UpsertUserDtoToJSON(value?: UpsertUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'email': value.email,
        'roles': value.roles,
        'password': value.password,
        'userGroupId': value.userGroupId,
        'apiKey': value.apiKey,
    };
}

